import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { Home } from './pages/Home'
import AiPhotobooth from './pages/AiPhotobooth/AiPhotobooth'
import NexaSync from './pages/NexaSync/NexaSync'
import TermsOfService from './pages/TermsOfService/TermsOfService'
import PrivacyPolicy from './pages/PrivacyPolicy/PrivacyPolicy'
import RefundPolicy from './pages/RefundPolicy/RefundPolicy'
import './util'

export const App = () => (
  <Router>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/ai-photobooth" element={<AiPhotobooth />} />
      <Route path="/nexasync" element={<NexaSync />} />
      <Route path="/terms-of-service" element={<TermsOfService />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/refund-policy" element={<RefundPolicy />} />
    </Routes>
  </Router>
)
